import { reactive } from 'vue'

const memoryItemTypes = reactive([
  {
    id: 1,
    name: '電車',
    iconUrl: 'icons/memoryItems/train.svg',
  },
  {
    id: 2,
    name: '車',
    iconUrl: 'icons/memoryItems/car.svg',
  },
  {
    id: 3,
    name: '飛行機',
    iconUrl: 'icons/memoryItems/plane.svg',
  },
  {
    id: 4,
    name: '宿泊費',
    iconUrl: 'icons/memoryItems/pillow.svg',
  },
  {
    id: 5,
    name: 'パック旅行',
    iconUrl: 'icons/memoryItems/luggage.svg',
  },
  {
    id: 6,
    name: 'その他',
    iconUrl: 'icons/memoryItems/star.svg',
  },
])

export const useMemoryItems = () => {
  // const { currentPoliticalAction } = usePoliticalActions()
  // const memoryItems = ref(currentPoliticalAction.memory.expenses)
  // const removeItem = item => {
  //   const index = memoryItems.value.findIndex(element => {
  //     return element.id == item.id
  //   })
  //   memoryItems.value.splice(index, 1)
  // }

  const getIcon = memoryItemType => {
    console.log("getIcon in memoryItemType",memoryItemType)
    if (
      memoryItemType == null ||
      memoryItemType.length == 0 ||
      memoryItemType[0] == undefined ||
      !memoryItemType[0]['iconUrl']
    ) {
      return ''
    }
    return require('../../assets/' + memoryItemType[0]['iconUrl'])
  }

  return { memoryItemTypes, getIcon }
}
